import * as Sentry from '@sentry/react'

export default {
  init: (options) => {
    console.log('init')
    if (process.env.REACT_APP_ENV !== 'local') {
      return Sentry.init(options)
    } else {
      console.log('init', options)
    }
  },
  captureException: (exception, captureContext) => {
    if (process.env.REACT_APP_ENV !== 'local') {
      return Sentry.captureException(exception, captureContext)
    } else {
      console.log('captureException', exception, captureContext)
    }
  },
  captureMessage: (message) => {
    if (process.env.REACT_APP_ENV !== 'local') {
      return Sentry.captureMessage(message, Sentry.Severity.Info)
    } else {
      console.log('captureMessage', message)
    }
  },
  addBreadcrumb: (category, message, data) => {
    if (process.env.REACT_APP_ENV !== 'local') {
      return Sentry.addBreadcrumb({ category, message, data, level: Sentry.Severity.Info })
    }
  },
}
